/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'swap': {
    width: 62,
    height: 62,
    viewBox: '0 0 62 62',
    data: `<defs><clipPath id="svgicon_swap_a"><path pid="0" d="M0 0h62v62H0z"/></clipPath></defs><g _fill="none" _stroke="#fff" stroke-width="1.5" clip-path="url(#svgicon_swap_a)"><path pid="1" d="M48.425 30.5l12.075 12-12.075 12M13.5 42.313h46.925"/><g><path pid="2" d="M13.575 31.501l-12.075-12 12.075-12M48.5 19.688H1.575"/></g></g>`
  }
})
/* tslint:enable */
